import { STRATEGY_SESSION_MAPPING } from '@Saral-Influencer-Marketing/saral-utils/src/constants/support';

const getStrategySessionLink = (trialGrantedBy: string = '') => {
  const validLink = hasKey(STRATEGY_SESSION_MAPPING, trialGrantedBy);
  if (!validLink) {
    return STRATEGY_SESSION_MAPPING['support@getsaral.com'];
  }
  //@ts-ignore
  return STRATEGY_SESSION_MAPPING[trialGrantedBy];
};

const hasKey = (obj: object, key: string) => Object.keys(obj).includes(key);

export { getStrategySessionLink };
